
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-I-scale-up",
      function () {
        return require("private-next-pages/tnpsc-group-I-scale-up/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-I-scale-up"])
      });
    }
  